import { getQueryString } from './url';
import { format } from 'date-fns';

export function log(str: string) {
  const now = new Date();
  console.log(`${format(now, 'yyyy-MM-dd HH:mm:ss')} | ${str}`);
}

export async function sleep(time = 1000) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

export async function sleepMock<T>(data: T, time = 1000) {
  return new Promise<T>((resolve) => {
    setTimeout(() => {
      resolve(data);
    }, time);
  });
}

export function isFromActiveCache(): boolean {
  return +getQueryString('from_active_cache') === 1;
}

export function isNU(v: any): boolean {
  return v === null || v === undefined;
}

// 判断是不是ios的移动设备
export const isIOS = () => !!navigator.userAgent.match(/(iPhone|iPod|iPad)/i);

/**
 * 数字格式化函数
 * @param num 要格式化的数字 (支持 number、string、null、undefined 类型)
 * @param enableRounding 是否启用四舍五入，默认为 true
 *   - true: 使用 toFixed(2) 进行四舍五入 (例: 1234567 -> "1.23M")
 *   - false: 使用 Math.floor 向下取整 (例: 1234567 -> "1M")
 * @returns 格式化后的字符串
 *   - >= 1000000: 转换为 M 单位 (例: 1000000 -> "1.00M" 或 "1M")
 *   - >= 1000: 转换为 K 单位 (例: 1000 -> "1.00K" 或 "1K")
 *   - < 1000: 直接返回原数字字符串
 *   - 无效值: 返回 "0"
 */
export function formatNumber(num: number | string | null | undefined, enableRounding: boolean = true): string {
  if (!num || num === 0) return '0';

  const numValue = typeof num === 'string' ? parseFloat(num) : num;

  if (isNaN(numValue)) return '0';

  if (numValue >= 1000000) {
    if (enableRounding) {
      return (numValue / 1000000).toFixed(2) + 'M';
    } else {
      return Math.floor(numValue / 1000000) + 'M';
    }
  } else if (numValue >= 1000) {
    if (enableRounding) {
      return (numValue / 1000).toFixed(2) + 'K';
    } else {
      return Math.floor(numValue / 1000) + 'K';
    }
  }
  console.log("formatNumber11",numValue)
  return numValue.toString();
}
/**
 * 格式化时间，输入是秒数
 * @param seconds 秒数
 * @returns 格式化后的字符串 (例: 100 -> 00:01:40)
 */
export function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}
